var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrap-search"},[(_vm.users[0])?_c('ModuleSearch',{attrs:{"users":_vm.users}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }